import { useState } from 'react';
import { Checkbox, message } from 'antd';
import PSAIModal from '@PSAIComponents/PSAIModal';
import API from '@api/api';
import styles from './index.module.scss';

/**
 * 删除文件夹弹窗组件
 * @param {boolean} open - 是否显示
 * @param {string} folderId - 要删除的文件夹ID
 * @param {function} onSuccess - 删除成功回调
 * @param {function} onCancel - 取消回调
 */
const DeleteFolderModal = ({ open, folderId, onSuccess, onCancel }) => {
    const [cascade, setCascade] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleOk = () => {
        setLoading(true);
        API.materialFolderDelete({ folderId, cascade })
            .then((res) => {
                if (res.code === 0) {
                    message.success('删除成功');
                    setCascade(false);
                    onSuccess?.();
                } else {
                    message.error(res.message || '删除失败');
                }
            })
            .catch(() => {
                message.error('删除失败，请稍后重试');
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleCancel = () => {
        setCascade(false);
        onCancel?.();
    };

    return (
        <PSAIModal
            title="删除文件夹"
            open={open}
            onOk={handleOk}
            onCancel={handleCancel}
            maxWidth={460}
            confirmLoading={loading}
            okText="删除"
        >
            <div className={styles.deleteContent}>
                <div className={styles.deleteTitle}>确定要删除此文件夹吗？</div>
                <div className={styles.deleteWarning}>
                    此操作不可复原
                </div>
                <div className={styles.cascadeCheck}>
                    <Checkbox
                        checked={cascade}
                        onChange={(e) => setCascade(e.target.checked)}
                    >
                        同时删除文件夹中所有图片
                    </Checkbox>
                </div>
            </div>
        </PSAIModal>
    );
};

export default DeleteFolderModal;
